import React from "react";

const BuyIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="16" fill="#002035" />
      <path
        d="M12.8 18.2399C15.451 18.2399 17.6 16.0909 17.6 13.4399C17.6 10.7889 15.451 8.63989 12.8 8.63989C10.149 8.63989 8 10.7889 8 13.4399C8 16.0909 10.149 18.2399 12.8 18.2399Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5565 14.0549C19.5254 13.3373 21.7322 13.98 23.008 15.6425C24.2838 17.3049 24.3336 19.6029 23.1311 21.3191C21.9286 23.0353 19.7518 23.7731 17.7536 23.1416C15.7554 22.5101 14.3979 20.6554 14.4 18.5598C14.4016 18.3541 14.4161 18.1487 14.4435 17.9448"
        stroke="white"
        strokeLinejoin="round"
      />
      <path
        d="M24.0001 11.2L22.7201 13.12L21.4401 11.2"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.6 8H20.16C21.5738 8 22.72 9.14615 22.72 10.56V13.12"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 20.8001L9.28 18.8801L10.56 20.8001"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.4 24.0001H11.84C10.4261 24.0001 9.27997 22.854 9.27997 21.4401V18.8801"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.2601 12.0398H13.36C13.7467 12.0398 14.0601 12.3533 14.0601 12.74C14.0601 13.1266 13.7467 13.4401 13.36 13.4401"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.2601 14.8401H13.6397C14.0263 14.8401 14.3398 14.5267 14.3398 14.14C14.3398 13.7533 14.0263 13.4398 13.6397 13.4398H11.8201"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8195 12.0403V14.8403"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12.0275 12.0403V11.2" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.2902 12.0403V11.2" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M12.0275 15.6799V14.8402"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.2902 15.6799V14.8402"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.2682 17.164H18.8442C18.5898 17.1563 18.3514 17.2876 18.2219 17.5067C18.0925 17.7258 18.0925 17.998 18.2219 18.2171C18.3514 18.4362 18.5898 18.5676 18.8442 18.5599H19.5559C19.8103 18.5522 20.0487 18.6835 20.1782 18.9026C20.3076 19.1217 20.3076 19.3939 20.1782 19.613C20.0487 19.8321 19.8103 19.9634 19.5559 19.9557H18.1319"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M19.2 16.3199V17.1641" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M19.2 19.9558V20.8" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default BuyIcon;
